import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import { useHeaderConfig } from "@/hooks/useHeaderConfig";
import { CalendlyButton } from "@/components/CalendlyButton";
import { CallButton } from "@/components/CallButton";
import { PrimaryCtaButton } from "@/components/PrimaryCtaButton";
import { ThemeToggle } from "@/components/ThemeToggle";
import { NavLinks } from "@/components/navbar/NavLinks";
import { MobileMenu } from "@/components/navbar/MobileMenu";
import { BrandLogo } from "@/components/BrandLogo";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileExpanded, setMobileExpanded] = useState(null);
  const location = useLocation();
  const { navStructure } = useHeaderConfig();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    setMobileExpanded(null);
  }, [location.pathname]);

  return (
    <>
      <header
        data-testid="site-navbar"
        className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
          scrolled ? "bg-white/70 dark:bg-black/70 backdrop-blur-2xl border-b border-slate-200 dark:border-white/10" : "bg-transparent border-b border-transparent"
        }`}
      >
        <div className="container-px mx-auto flex items-center justify-between h-20">
          <BrandLogo testId="navbar-logo-link" hideTextOnMobile />

          <NavLinks navStructure={navStructure} openDropdown={openDropdown} setOpenDropdown={setOpenDropdown} />

          <div className="hidden md:flex items-center gap-2">
            <ThemeToggle />
            <span className="hidden xl:inline-flex">
              <CallButton className="btn-outline inline-flex items-center gap-2 text-sm" testId="navbar-call-button" />
            </span>
            <CalendlyButton className="btn-outline inline-flex items-center gap-2 text-sm" testId="navbar-book-call-button" />
            <PrimaryCtaButton className="btn-gradient inline-flex items-center gap-2 text-sm" testId="navbar-cta-button" />
          </div>

          <div className="flex items-center gap-2 md:hidden">
            <ThemeToggle />
            <button
              data-testid="navbar-mobile-toggle"
              onClick={() => setOpen((v) => !v)}
              className="text-slate-900 dark:text-white p-2 -mr-2"
              aria-label="Toggle navigation"
            >
              {open ? <X size={26} /> : <List size={26} />}
            </button>
          </div>
        </div>
      </header>

      <MobileMenu open={open} navStructure={navStructure} mobileExpanded={mobileExpanded} setMobileExpanded={setMobileExpanded} />
    </>
  );
};
